module.exports = __webpack_public_path__ + "img/donald-trump-countdown.9dcca482.svg";